import { Component, OnInit, Input } from '@angular/core';
declare let pg: any;

@Component({
  selector: 'pg-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {
  _enableHorizontalContainer = false;
  _extraClass = '';
  _extraHorizontalClass = '';

  constructor() {}

  @Input()
  set extraClass(value) {
    this._extraClass = value;
  }

  @Input()
  set extraHorizontalClass(value) {
    this._extraHorizontalClass = value;
  }

  ngOnInit() {
    this._enableHorizontalContainer = pg.isHorizontalLayout;
  }
}
